var BOPPolicyChangeDraftDataExtension = function BOPPolicyChangeDraftDataExtension(policyChange) {
    var _this = this;

    if (policyChange.lobData.businessOwners) {
        var bop = policyChange.lobData.businessOwners;
        Object.keys(bop).forEach(function (prop) {
            if (bop.hasOwnProperty(prop)) {
                _this[prop] = bop[prop];
            }
        });
    } else {
        this.accountOrgType = null;
        this.smallBusinessType = null;
    }
};

export default BOPPolicyChangeDraftDataExtension;


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=BusinessOwners!./common/js/src/edge/gw-portals-policytransaction-pc-bop-js/models/BOPPolicyChangeDataExtension.js
// module id = 435
// module chunks = 0